import { createIcon } from './icon-utils';

export const SmallDownArrowIcon = createIcon({
  path: 'M9.328 4.635c.3-.286.775-.275 1.06.025.287.3.276.774-.024 1.06L6.846 9.08c-.186.178-.435.276-.692.276-.257 0-.506-.098-.692-.276L1.944 5.72c-.3-.286-.31-.76-.025-1.06.286-.3.76-.31 1.06-.025l3.175 3.031 3.174-3.03z',
  viewBox: '0 0 12 12',
});
